import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { ModalAprovarPixService } from './modal-aprovar-pix.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'ngx-modal-aprovar-pix',
  templateUrl: './modal-aprovar-pix.component.html',
  styleUrls: ['./modal-aprovar-pix.component.scss']
})
export class ModalAprovarPixComponent implements OnInit {

  @Input() id: string;
  @Input() nomeSolicitante: string;
  @Input() cpfCnpj: string;
  @Input() valorAntigo: string;
  @Input() valorNovo: string;

  @ViewChild("card", null)
  private card: ElementRef;
  public tamanho: number = 200;

  @ViewChild("inputFileLabel", null)
  private inputFileLabel: ElementRef;
  public formModalAprovar = null;
  public file: any;
  public isDisabledSaveButton: boolean = true;
  public isDisabledReprovaButton: boolean = true;
  public tableLimit = 12;
  public customLogin = null;


  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalAprovarPixComponent>,
    private service: ModalAprovarPixService,
    private notificationsService: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private paginationService: SpringDatatablePaginationService,

  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.card.nativeElement.ownerDocument.activeElement.blur();

    this.formModalAprovar = this.formBuilder.group({
      observacao: [null],

    });

  }

  reprovarPix(data) {

    let register = {

      observacao: data.observacao,
      solicitacaoAumentoLimiteId: this.id,
      statusSolicitacao: 'REJEITADA',

    }

    this.aprovarReprovar(register)
  };

  aprovarPix(data) {

    let register = {

      observacao: data.observacao,
      solicitacaoAumentoLimiteId: this.id,
      statusSolicitacao: 'APROVADA',

    }

    this.aprovarReprovar(register)

  };

  qdadeCaracteres() {

    let inpuBox = document.querySelector(".input-box"),
      textArea = inpuBox.querySelector("textarea");
    var caracteresRestantes = 200;

    textArea.addEventListener("keyup", () => {

      let valLenght = textArea.value.length;
      this.tamanho = caracteresRestantes - valLenght;

      valLenght < 30
        ? inpuBox.classList.add("error")
        : inpuBox.classList.remove("error");

      if (this.tamanho <= 170) {
        this.isDisabledSaveButton = false;
        this.isDisabledReprovaButton = false;

      } else {
        this.isDisabledSaveButton = true;
        this.isDisabledReprovaButton = true;
      }

    });

  }

  aprovarReprovar(data) {

    this.spinnerService.show();
    this.service.aprovarReprovar(data, (response) => {

      this.spinnerService.hide();
      this.notificationsService.success(response.message)
      this.atualizarPedido();

    }, (error) => {
      this.spinnerService.hide();
      this.notificationsService.error(error.message)
    });

    this.ref.close();

  }

  atualizarPedido() {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    this.service.aprovacaoPix(params, (response => {

      this.paginationService.setInfo(response)

    }), null);

  }

  voltar() {

    this.ref.close();

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }
}
